import { render, staticRenderFns } from "./activity-activi_draw_en.vue?vue&type=template&id=ca0ab1a2&scoped=true&"
import script from "./activity-activi_draw_en.vue?vue&type=script&lang=js&"
export * from "./activity-activi_draw_en.vue?vue&type=script&lang=js&"
import style0 from "./activity-activi_draw_en.vue?vue&type=style&index=0&id=ca0ab1a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca0ab1a2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Atlas: require('/var/jenkins_home/workspace/prod-web-xfans/components/atlas.vue').default})
